export class EssenceLookupTables {

    constructor() {
        this.sortedEssenceGroupIds = [
            "greed",
            "contempt",
            "hatred",
            "woe",
            "fear",
            "anger",
            "torment",
            "sorrow",
            "rage",
            "suffering",
            "wrath",
            "doubt",
            "loathing",
            "zeal",
            "anguish",
            "spite",
            "scorn",
            "envy",
            "misery",
            "dread",
            "insanity",
            "horror",
            "delirium",
            "hysteria"
        ];

        this.essenceGroups = {
            "greed": {
                tier: 1,
                essenceIds: [
                    "Metadata/Items/Currency/CurrencyEssenceGreed7",
                    "Metadata/Items/Currency/CurrencyEssenceGreed6",
                    "Metadata/Items/Currency/CurrencyEssenceGreed5",
                    "Metadata/Items/Currency/CurrencyEssenceGreed4",
                    "Metadata/Items/Currency/CurrencyEssenceGreed3",
                    "Metadata/Items/Currency/CurrencyEssenceGreed2",
                    "Metadata/Items/Currency/CurrencyEssenceGreed1",
                ]
            },
            "contempt": {
                tier: 1,
                essenceIds: [
                    "Metadata/Items/Currency/CurrencyEssenceContempt7",
                    "Metadata/Items/Currency/CurrencyEssenceContempt6",
                    "Metadata/Items/Currency/CurrencyEssenceContempt5",
                    "Metadata/Items/Currency/CurrencyEssenceContempt4",
                    "Metadata/Items/Currency/CurrencyEssenceContempt3",
                    "Metadata/Items/Currency/CurrencyEssenceContempt2",
                    "Metadata/Items/Currency/CurrencyEssenceContempt1",
                ]
            },
            "hatred": {
                tier: 1,
                essenceIds: [
                    "Metadata/Items/Currency/CurrencyEssenceHatred7",
                    "Metadata/Items/Currency/CurrencyEssenceHatred6",
                    "Metadata/Items/Currency/CurrencyEssenceHatred5",
                    "Metadata/Items/Currency/CurrencyEssenceHatred4",
                    "Metadata/Items/Currency/CurrencyEssenceHatred3",
                    "Metadata/Items/Currency/CurrencyEssenceHatred2",
                    "Metadata/Items/Currency/CurrencyEssenceHatred1",
                ]
            },
            "woe": {
                tier: 1,
                essenceIds: [
                    "Metadata/Items/Currency/CurrencyEssenceWoe7",
                    "Metadata/Items/Currency/CurrencyEssenceWoe6",
                    "Metadata/Items/Currency/CurrencyEssenceWoe5",
                    "Metadata/Items/Currency/CurrencyEssenceWoe4",
                    "Metadata/Items/Currency/CurrencyEssenceWoe3",
                    "Metadata/Items/Currency/CurrencyEssenceWoe2",
                    "Metadata/Items/Currency/CurrencyEssenceWoe1",
                ]
            },
            "fear": {
                tier: 2,
                essenceIds: [
                    "Metadata/Items/Currency/CurrencyEssenceFear6",
                    "Metadata/Items/Currency/CurrencyEssenceFear5",
                    "Metadata/Items/Currency/CurrencyEssenceFear4",
                    "Metadata/Items/Currency/CurrencyEssenceFear3",
                    "Metadata/Items/Currency/CurrencyEssenceFear2",
                    "Metadata/Items/Currency/CurrencyEssenceFear1",
                ]
            },
            "anger": {
                tier: 2,
                essenceIds: [
                    "Metadata/Items/Currency/CurrencyEssenceAnger6",
                    "Metadata/Items/Currency/CurrencyEssenceAnger5",
                    "Metadata/Items/Currency/CurrencyEssenceAnger4",
                    "Metadata/Items/Currency/CurrencyEssenceAnger3",
                    "Metadata/Items/Currency/CurrencyEssenceAnger2",
                    "Metadata/Items/Currency/CurrencyEssenceAnger1",
                ]
            },
            "torment": {
                tier: 2,
                essenceIds: [
                    "Metadata/Items/Currency/CurrencyEssenceTorment6",
                    "Metadata/Items/Currency/CurrencyEssenceTorment5",
                    "Metadata/Items/Currency/CurrencyEssenceTorment4",
                    "Metadata/Items/Currency/CurrencyEssenceTorment3",
                    "Metadata/Items/Currency/CurrencyEssenceTorment2",
                    "Metadata/Items/Currency/CurrencyEssenceTorment1",
                ]
            },
            "sorrow": {
                tier: 2,
                essenceIds: [
                    "Metadata/Items/Currency/CurrencyEssenceSorrow6",
                    "Metadata/Items/Currency/CurrencyEssenceSorrow5",
                    "Metadata/Items/Currency/CurrencyEssenceSorrow4",
                    "Metadata/Items/Currency/CurrencyEssenceSorrow3",
                    "Metadata/Items/Currency/CurrencyEssenceSorrow2",
                    "Metadata/Items/Currency/CurrencyEssenceSorrow1",
                ]
            },
            "rage": {
                tier: 3,
                essenceIds: [
                    "Metadata/Items/Currency/CurrencyEssenceRage5",
                    "Metadata/Items/Currency/CurrencyEssenceRage4",
                    "Metadata/Items/Currency/CurrencyEssenceRage3",
                    "Metadata/Items/Currency/CurrencyEssenceRage2",
                    "Metadata/Items/Currency/CurrencyEssenceRage1",
                ]
            },
            "suffering": {
                tier: 3,
                essenceIds: [
                    "Metadata/Items/Currency/CurrencyEssenceSuffering5",
                    "Metadata/Items/Currency/CurrencyEssenceSuffering4",
                    "Metadata/Items/Currency/CurrencyEssenceSuffering3",
                    "Metadata/Items/Currency/CurrencyEssenceSuffering2",
                    "Metadata/Items/Currency/CurrencyEssenceSuffering1",
                ]
            },
            "wrath": {
                tier: 3,
                essenceIds: [
                    "Metadata/Items/Currency/CurrencyEssenceWrath5",
                    "Metadata/Items/Currency/CurrencyEssenceWrath4",
                    "Metadata/Items/Currency/CurrencyEssenceWrath3",
                    "Metadata/Items/Currency/CurrencyEssenceWrath2",
                    "Metadata/Items/Currency/CurrencyEssenceWrath1",
                ]
            },
            "doubt": {
                tier: 3,
                essenceIds: [
                    "Metadata/Items/Currency/CurrencyEssenceDoubt5",
                    "Metadata/Items/Currency/CurrencyEssenceDoubt4",
                    "Metadata/Items/Currency/CurrencyEssenceDoubt3",
                    "Metadata/Items/Currency/CurrencyEssenceDoubt2",
                    "Metadata/Items/Currency/CurrencyEssenceDoubt1",
                ]
            },
            "loathing": {
                tier: 4,
                essenceIds: [
                    "Metadata/Items/Currency/CurrencyEssenceLoathing4",
                    "Metadata/Items/Currency/CurrencyEssenceLoathing3",
                    "Metadata/Items/Currency/CurrencyEssenceLoathing2",
                    "Metadata/Items/Currency/CurrencyEssenceLoathing1",
                ]
            },
            "zeal": {
                tier: 4,
                essenceIds: [
                    "Metadata/Items/Currency/CurrencyEssenceZeal4",
                    "Metadata/Items/Currency/CurrencyEssenceZeal3",
                    "Metadata/Items/Currency/CurrencyEssenceZeal2",
                    "Metadata/Items/Currency/CurrencyEssenceZeal1",
                ]
            },
            "anguish": {
                tier: 4,
                essenceIds: [
                    "Metadata/Items/Currency/CurrencyEssenceAnguish4",
                    "Metadata/Items/Currency/CurrencyEssenceAnguish3",
                    "Metadata/Items/Currency/CurrencyEssenceAnguish2",
                    "Metadata/Items/Currency/CurrencyEssenceAnguish1",
                ]
            },
            "spite": {
                tier: 4,
                essenceIds: [
                    "Metadata/Items/Currency/CurrencyEssenceSpite4",
                    "Metadata/Items/Currency/CurrencyEssenceSpite3",
                    "Metadata/Items/Currency/CurrencyEssenceSpite2",
                    "Metadata/Items/Currency/CurrencyEssenceSpite1",
                ]
            },
            "scorn": {
                tier: 5,
                essenceIds: [
                    "Metadata/Items/Currency/CurrencyEssenceScorn3",
                    "Metadata/Items/Currency/CurrencyEssenceScorn2",
                    "Metadata/Items/Currency/CurrencyEssenceScorn1",
                ]
            },
            "envy": {
                tier: 5,
                essenceIds: [
                    "Metadata/Items/Currency/CurrencyEssenceEnvy3",
                    "Metadata/Items/Currency/CurrencyEssenceEnvy2",
                    "Metadata/Items/Currency/CurrencyEssenceEnvy1",
                ]
            },
            "misery": {
                tier: 5,
                essenceIds: [
                    "Metadata/Items/Currency/CurrencyEssenceMisery3",
                    "Metadata/Items/Currency/CurrencyEssenceMisery2",
                    "Metadata/Items/Currency/CurrencyEssenceMisery1",
                ]
            },
            "dread": {
                tier: 5,
                essenceIds: [
                    "Metadata/Items/Currency/CurrencyEssenceDread3",
                    "Metadata/Items/Currency/CurrencyEssenceDread2",
                    "Metadata/Items/Currency/CurrencyEssenceDread1",
                ]
            },
            "insanity": {
                tier: 6,
                essenceIds: [
                    "Metadata/Items/Currency/CurrencyEssenceInsanity1",
                ]
            },
            "horror": {
                tier: 6,
                essenceIds: [
                    "Metadata/Items/Currency/CurrencyEssenceHorror1",
                ]
            },
            "delirium": {
                tier: 6,
                essenceIds: [
                    "Metadata/Items/Currency/CurrencyEssenceDelirium1",
                ]
            },
            "hysteria": {
                tier: 6,
                essenceIds: [
                    "Metadata/Items/Currency/CurrencyEssenceHysteria1",
                ]
            },
        }
    }

    getSortedEssenceGroupIds() {
        return this.sortedEssenceGroupIds;
    }

    getGroupByGroupId(groupId) {
        return this.essenceGroups[groupId];
    }
}

// eslint-disable-next-line no-unused-vars
export function ParseEssences(essences) {
    let essenceLookupTables = new EssenceLookupTables();

    // Everything's hard coded here for now
    return essenceLookupTables;
}

export default { ParseEssences };